"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNftPurchaseCartItemsResultErrorToJSON = exports.ValidateNftPurchaseCartItemsResultErrorFromJSONTyped = exports.ValidateNftPurchaseCartItemsResultErrorFromJSON = void 0;
function ValidateNftPurchaseCartItemsResultErrorFromJSON(json) {
    return ValidateNftPurchaseCartItemsResultErrorFromJSONTyped(json, false);
}
exports.ValidateNftPurchaseCartItemsResultErrorFromJSON = ValidateNftPurchaseCartItemsResultErrorFromJSON;
function ValidateNftPurchaseCartItemsResultErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorMessage': json['errorMessage'],
        'nftSaleConfigId': json['nftSaleConfigId'],
    };
}
exports.ValidateNftPurchaseCartItemsResultErrorFromJSONTyped = ValidateNftPurchaseCartItemsResultErrorFromJSONTyped;
function ValidateNftPurchaseCartItemsResultErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorMessage': value.errorMessage,
        'nftSaleConfigId': value.nftSaleConfigId,
    };
}
exports.ValidateNftPurchaseCartItemsResultErrorToJSON = ValidateNftPurchaseCartItemsResultErrorToJSON;
